export default "\n<app-navbar></app-navbar>\n<app-loader></app-loader>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n"